// extracted by mini-css-extract-plugin
module.exports = {"Card":"LineCard_Card__3pgOq","description":"LineCard_description__2_7H6","loader":"LineCard_loader__1WwI_","FullWidthTable":"LineCard_FullWidthTable__3qYty"};